<template>
  <div class="container">
    <h1>Valet Parking - Reservaciones Confirmadas</h1>

    <!-- Selector de fecha -->
    <div class="date-picker">
      <label for="date">Selecciona un día:</label>
      <input type="date" v-model="selectedDate" @change="filterReservations" />
    </div>

    <!-- Calendario para escritorio -->
    <div class="calendar-container" v-if="!isMobileView">
      <FullCalendar :options="calendarOptions" class="calendar" />
    </div>

    <!-- Lista de reservas para móviles -->
    <div class="reservations-list" v-else>
      <ul>
        <li v-for="res in filteredReservations" :key="res.id">
          <strong>{{ formatTime(res.time) }}</strong>: {{ res.name }}
          <span v-if="res.people" class="valet-people">· {{ res.people }} personas</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { collection, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/init';
import { formatLocalDate } from '../utils/date';
import { formatTimeLabel } from '../utils/time';
import FullCalendar from '@fullcalendar/vue3';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';

export default {
  name: 'ValetParkingView',
  components: {
    FullCalendar,
  },
  setup() {
    const reservations = ref([]);
    const filteredReservations = ref([]);
    const selectedDate = ref(formatLocalDate(new Date())); // Fecha actual por defecto

    const calendarOptions = ref({
      plugins: [dayGridPlugin, timeGridPlugin],
      initialView: 'timeGridDay',
      timeZone: 'America/Puerto_Rico',
      slotLabelFormat: {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
      },
      eventTimeFormat: {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
      },
      events: [],
    });

    const isMobileView = ref(window.innerWidth <= 768);

    const handleResize = () => {
      isMobileView.value = window.innerWidth <= 768;
    };

    window.addEventListener('resize', handleResize);

    onMounted(() => {
      const q = collection(db, 'reservations');

      onSnapshot(q, (snapshot) => {
        if (!snapshot.empty) {
          reservations.value = snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          filterReservations();
          calendarOptions.value.events = reservations.value
            .filter((res) => res.status === 'confirmed')
            .map((res) => ({
              id: res.id,
              title: `${res.name} · ${res.people || '?'} personas`,
              start: `${res.date}T${res.time}`,
            }));
        }
      });
    });

    const formatTime = (time) => formatTimeLabel(time);

    const filterReservations = () => {
      filteredReservations.value = reservations.value
        .filter((res) => res.date === selectedDate.value && res.status === 'confirmed')
        .sort((a, b) => a.time.localeCompare(b.time));
    };

    return {
      calendarOptions,
      reservations,
      filteredReservations,
      selectedDate,
      formatTime,
      isMobileView,
      filterReservations,
    };
  },
};
</script>

<style scoped src="./ValetParkingView.css"></style>
